import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/auth": [7],
		"/auth/sign-in": [8],
		"/balances": [9],
		"/dashboard": [10,[2]],
		"/dashboard/achievements": [11,[2]],
		"/dashboard/leaderboard": [12,[2]],
		"/dashboard/missions": [13,[2]],
		"/dashboard/rewards": [14,[2]],
		"/dashboard/wallets": [15,[2]],
		"/eudrop/claim": [16,[3]],
		"/explorer": [17],
		"/explorer/channels": [18],
		"/explorer/clients": [19],
		"/explorer/connections": [20],
		"/explorer/find-packet": [21],
		"/explorer/orbital": [22],
		"/explorer/packets": [23],
		"/explorer/packets/incomplete": [25],
		"/explorer/packets/[packet_hash]": [24,[4]],
		"/explorer/stakes/[packet_hash]": [26],
		"/explorer/tokens": [27],
		"/explorer/transfers": [28],
		"/explorer/transfers/[packet_hash]": [29,[5]],
		"/explorer/unstakes/[packet_hash]": [30],
		"/faucet": [31],
		"/health": [32],
		"/liquid-staking": [33],
		"/nodes": [34],
		"/privacy-policy": [35],
		"/stake": [36],
		"/transfers": [41],
		"/transfer": [37],
		"/transfer/multisig": [38],
		"/transfer/native": [39],
		"/transfer/ts-packets": [40],
		"/yaps": [42]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';